"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselFooterButton: function() {
        return _TeachingPopoverCarouselFooterButton.TeachingPopoverCarouselFooterButton;
    },
    renderTeachingPopoverCarouselFooterButton_unstable: function() {
        return _renderTeachingPopoverCarouselFooterButton.renderTeachingPopoverCarouselFooterButton_unstable;
    },
    teachingPopoverCarouselFooterButtonClassNames: function() {
        return _useTeachingPopoverCarouselFooterButtonStylesstyles.teachingPopoverCarouselFooterButtonClassNames;
    },
    useTeachingPopoverCarouselFooterButtonStyles_unstable: function() {
        return _useTeachingPopoverCarouselFooterButtonStylesstyles.useTeachingPopoverCarouselFooterButtonStyles_unstable;
    },
    useTeachingPopoverCarouselFooterButton_unstable: function() {
        return _useTeachingPopoverCarouselFooterButton.useTeachingPopoverCarouselFooterButton_unstable;
    }
});
const _TeachingPopoverCarouselFooterButton = require("./TeachingPopoverCarouselFooterButton");
const _renderTeachingPopoverCarouselFooterButton = require("./renderTeachingPopoverCarouselFooterButton");
const _useTeachingPopoverCarouselFooterButton = require("./useTeachingPopoverCarouselFooterButton");
const _useTeachingPopoverCarouselFooterButtonStylesstyles = require("./useTeachingPopoverCarouselFooterButtonStyles.styles");
